import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 获取店员头像框信息
 */
export const listClerkAvatarFrame = ()=>{
    return axios.request({
        url: '/s/c/avatarFrame/list',
        method: 'get'
    })
}

/**
 * 保存店员头像框
 */
export const saveClerkAvatarFrame = (clerkAvatarFrameLogId)=>{
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'clerkAvatarFrameLogId',clerkAvatarFrameLogId)
    return axios.request({
        url: '/s/c/avatarFrame/save',
        data,
        method: 'post'
    })
}

